import { useCallback, useEffect, useState } from "react"
import { Modal } from "common/Modal"
import { useNotifications } from "hooks/useNotification"
import Select from "react-select"

import UserService from "services/user.service"
import { useDebounce } from "hooks/useDebounce"

const service = new UserService()

const DEFAULT_STATE = {
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  social_media_ad_id: "",
  companyId: "",
  source: {
    source: "",
  },
  candidate: {
    leader_id: "",
    leader_name: "",
  },
}

export const AddCandidateModal = ({
  evo = false,
  vivint = false,
  addModal,
  fetchData,
  setAddModal,
}: {
  evo?: boolean
  vivint?: boolean
  addModal: boolean
  fetchData: () => void
  setAddModal: (v: boolean) => void
}) => {
  const [state, setState] = useState(DEFAULT_STATE)
  const [submitting, setSubmitting] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingUsers, setLoadingUsers] = useState(false)
  const [searchValue, setSearchValue] = useState("")
  const [users, setUsers] = useState([])
  const [companies, setCompanies] = useState([])
  const [companyUsers, setCompanyUsers] = useState([])

  const { errorMessage, successMessage } = useNotifications()

  const debbounced = useDebounce(searchValue, 500)

  const fetchComapnies = useCallback(() => {
    setLoading(true)
    service
      .getCompanies()
      .then((resp) => {
        setCompanies(resp.data.data)
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  useEffect(() => {
    setLoadingUsers(true)
    service
      .getSignedReps({
        repName: debbounced,
        pageNumber: 1,
        year: "All",
        pageSize: 100
      })
      .then((resp) => {
        setUsers(
          resp.data.data.map((item) => ({
            value: item.rep_id,
            label: item.rep_name,
          }))
        )
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoadingUsers(false)
      })
  }, [debbounced])

  useEffect(() => {
    fetchComapnies()
  }, [])

  const handleChange = (event) => {
    const { name, value } = event.target
    setState({
      ...state,
      [name]: value,
    })
  }

  const handleChangePhone = (e) => {
    let input = e.target.value

    // Remove any non-digit characters
    input = input.replace(/\D/g, "")

    // Limit to 10 digits maximum
    if (input.length > 10) {
      input = input.slice(0, 10)
    }

    setState({ ...state, phone: input })
  }

  const handleKeyPress = (e) => {
    // Only allow digits
    if (
      !/\d/.test(e.key) &&
      !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)
    ) {
      e.preventDefault()
    }
  }

  const handleChangeCompany = (event) => {
    const id = event.target.value
    const findCompany: any = companies.find(
      (company: { companyId: string }) => company.companyId === id
    )
    const badgeid = findCompany?.owner?.badgeId || ""

    setState({
      ...state,
      companyId: id,
    })
    service
      .companyUsers(id, badgeid || "")
      .then((resp) => {
        setCompanyUsers(resp.data.data)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleChangeCandidate = (e) => {
    const id = e.target.value
    const selectedOption = e.target.selectedOptions[0]
    const fullname = selectedOption.getAttribute("data-fullname")

    setState({
      ...state,
      candidate: {
        leader_id: id,
        leader_name: fullname,
      },
    })
  }
  const handleAddCandidate = (event) => {
    event.preventDefault()

    setSubmitting(true)

    if (state.phone.length !== 10) {
      errorMessage("Please enter 10 digits phone number without country code")
      return
    }

    const payload = {
      ...state,
      social_media_ad_id: state.social_media_ad_id.trim(),
    }

    if (vivint) {
      service
        .addVivintCandidate(payload)
        .then(() => {
          successMessage("Candidate added successfully")
          fetchData()
          setState(DEFAULT_STATE)
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          setSubmitting(false)
          setAddModal(false)
        })
    } else if (evo) {
      service
        .addEvoCandidate(payload)
        .then(() => {
          successMessage("Dealer candidate added successfully")
          fetchData()
          setState(DEFAULT_STATE)
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          setSubmitting(false)
          setAddModal(false)
        })
    } else {
      service
        .addDealerCandidate(payload)
        .then(() => {
          successMessage("Dealer candidate added successfully")
          fetchData()
          setState(DEFAULT_STATE)
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          setSubmitting(false)
          setAddModal(false)
        })
    }
  }

  return (
    <Modal
      width="w-full md:w-1/3"
      showModal={addModal}
      setShowModal={setAddModal}
      title="Add Candidate"
    >
      <form onSubmit={handleAddCandidate} className="flex flex-col gap-3">
        <div className="grid grid-cols-2 gap-3">
          <div className="flex flex-col gap-1">
            <label className="field-label">Ad ID</label>
            <input
              type="text"
              placeholder="Enter Ad ID"
              value={state.social_media_ad_id}
              required
              name="social_media_ad_id"
              onChange={(e) => handleChange(e)}
              className="w-full px-3 py-2 text-sm"
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="field-label">First Name</label>
            <input
              type="text"
              placeholder="Enter first name"
              value={state.first_name}
              required
              name="first_name"
              onChange={(e) => handleChange(e)}
              className="w-full px-3 py-2 text-sm"
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="field-label">Last Name</label>
            <input
              type="text"
              placeholder="Enter last name"
              value={state.last_name}
              required
              name="last_name"
              onChange={(e) => handleChange(e)}
              className="w-full px-3 py-2 text-sm"
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="field-label">Email</label>
            <input
              type="email"
              placeholder="Enter email"
              value={state.email}
              required
              name="email"
              onChange={(e) => handleChange(e)}
              className="w-full px-3 py-2 text-sm"
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="field-label">Phone</label>
            <input
              type="number"
              placeholder="Enter phone number"
              value={state.phone}
              required
              name="phone"
              onChange={handleChangePhone}
              onKeyDown={handleKeyPress}
              className="w-full px-3 py-2 text-sm"
            />
          </div>
          {!evo && !vivint && (
            <div className="flex flex-col gap-1">
              <label className="field-label">Companies</label>
              <select
                onChange={handleChangeCompany}
                name="companyId"
                value={state.companyId}
                required
                className="w-full px-3 py-2 text-sm"
              >
                <option>Select</option>
                {companies.map((item: any) => (
                  <option key={item.companyId} value={item.companyId}>
                    {item.title}
                  </option>
                ))}
              </select>
            </div>
          )}
          {!evo && !vivint && (
            <div className="flex flex-col gap-1">
              <label className="field-label">Candidates</label>
              <select
                onChange={handleChangeCandidate}
                name="leader_id"
                required
                value={state.candidate.leader_id}
                className="w-full px-3 py-2 text-sm"
              >
                <option>Select</option>
                {companyUsers.map((item: any) => (
                  <option
                    key={item._id}
                    value={item.badgeId}
                    data-fullname={item.fullname}
                  >
                    {item.fullname}
                  </option>
                ))}
              </select>
            </div>
          )}

          {(evo || vivint) && <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
            <label className="field-label">User</label>
            <Select
              options={users}
              placeholder="Search"
              onChange={(ev: any) =>
                setState({
                  ...state,
                  candidate: {
                    leader_id: ev?.value,
                    leader_name: ev?.label,
                  },
                })
              }
              isLoading={loadingUsers}
              onInputChange={(newValue) => setSearchValue(newValue)}
              className="react-select"
              classNamePrefix="react-select"
            />
          </div>}
          <div className="flex flex-col gap-1">
            <label className="field-label">Source</label>
            <select
              onChange={(e) =>
                setState({ ...state, source: { source: e.target.value } })
              }
              name="source"
              value={state.source.source}
              className="w-full px-3 py-2 text-sm"
            >
              <option>Select</option>
              <option value="Social Media">Social Media</option>
              <option value="Indeed">Indeed</option>
              <option value="campus_reel">Campus Reel</option>
            </select>
          </div>
        </div>
        <button
          type="submit"
          disabled={submitting}
          className="py-2 text-white bg-ink hover:bg-gray-800 rounded-lg disabled:opacity-25"
        >
          {submitting ? "Saving..." : "Save"}
        </button>
      </form>
    </Modal>
  )
}
